export default __webpack_public_path__ + "static/media/math-fill-in-the-blank.4bd347c5.gif";